import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getIsDateWithinXDays } from '@wix/da-ds/pkg/Time/functions';
import CoreUpgradeIndicator from '@wix/da-ds/pkg/Indicators/CoreUpgrade';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import s from './CoreMenuItem.scss';
const CoreMenuItem = ({ className, hasCoreMembership, coreLevel, coreExpires })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const buyCoreKey = isMobile ? 'siteHeaderMobile.userMenu.buyCoreMembership' : 'siteHeader.userMenu.buyCoreMembership';
    // we have multiple features crossing here in order to know if we display
    // a new upgrade indicator to the core upgrade in the usermenu:
    // - usermenu_core_entry
    // - usermenu_core_entry_for_core_desktop
    const usermenu_core_entry = useFlag('usermenu_core_entry');
    const showUpgradeIndicator_usermenu_core_entry = !isMobile && usermenu_core_entry && !hasCoreMembership;
    const usermenu_core_entry_for_core_desktop = useFlag('usermenu_core_entry_for_core_desktop');
    const isUpgradableCoreLevel = coreLevel === 'core_access' || coreLevel === 'core_plus';
    const coreExpiresIn30 = coreExpires && getIsDateWithinXDays(coreExpires, 30);
    const showUpgradeIndicator_usermenu_core_entry_for_core_desktop = usermenu_core_entry_for_core_desktop && !isMobile && isUpgradableCoreLevel && coreExpiresIn30;
    const showUpgradeIndicator = showUpgradeIndicator_usermenu_core_entry || showUpgradeIndicator_usermenu_core_entry_for_core_desktop;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, hasCoreMembership && coreLevel && s[`package-${coreLevel}`])
    }, showUpgradeIndicator ? /*#__PURE__*/ React.createElement(CoreUpgradeIndicator, {
        className: classnames(hasCoreMembership && s['ds-override'])
    }, t(hasCoreMembership ? 'siteHeader.userMenu.coreMenuItem.upgradeCore' : 'siteHeader.userMenu.coreMenuItem.getCore')) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", null, hasCoreMembership && coreLevel ? t(`siteHeader.userMenu.coreLabel.${coreLevel}`) : t(buyCoreKey)), /*#__PURE__*/ React.createElement("span", null, !hasCoreMembership && /*#__PURE__*/ React.createElement(CoreBadge, {
        corePackage: coreLevel,
        className: s['core-icon'],
        size: "large"
    }))));
};
CoreMenuItem.displayName = 'CoreMenuItem';
export default CoreMenuItem;
